<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-select v-model="model.Name" 
                                      label="Name *" 
                                      autofocus 
                                       
                                      :options="dataSourceLookupGlobalConfigurationNames" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       :readonly="model.Id > 0"
                                      :rules="[val => !!val || 'Required',]"
                                      :error="fieldHasError('Name')"
                                      :error-message="fieldErrorMessage('Name')"
                                      
                                      @input="onNameChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.Value" type="text" 
                                     label="Value *" 
                                      
                                      
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('Value')"
                                     :error-message="fieldErrorMessage('Value')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './globalconfigurationaddeditmodel-dialog-screen.js'
</script>